import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=17f6a4e2&scoped=true"
import script from "./cookie-policy.vue?vue&type=script&lang=js"
export * from "./cookie-policy.vue?vue&type=script&lang=js"
import style0 from "./cookie-policy.vue?vue&type=style&index=0&id=17f6a4e2&prod&scoped=true&lang=css"
import style1 from "./cookie-policy.vue?vue&type=style&index=1&id=17f6a4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f6a4e2",
  null
  
)

export default component.exports